import { DateTime } from 'luxon';

export function dateTimeToApiCalendarDate(dt: DateTime): string | null {
    if (!dt.isValid) return null;
    return dt.toISODate();
}

export function dateTimeToApiUtcIsoZ(dt: DateTime): string | null {
    if (!dt.isValid) return null;
    const u = dt.toUTC();
    return `${u.toFormat('yyyy-MM-dd')}T${u.toFormat('HH:mm:ss.SSS')}Z`;
}
